module.exports = {"341371400":"宿州东部新城行政管理区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341371.json
// module id = 1242
// module chunks = 0